/* Fulgenix cart wiring — Bold Subscriptions selling plans (Phase 5)
   Locked IDs: variant 53476666704163, plans 7608303907 / 7608271139 / 7608172835 */

function addSubscriptionToCart(variantId, quantity, sellingPlanId) {
  var item = { id: variantId, quantity: quantity };
  if (sellingPlanId) item.selling_plan = sellingPlanId;
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [item] })
  })
    .then(function (response) {
      if (!response.ok) throw new Error('Cart add failed: ' + response.status);
      return response.json();
    })
    .then(function (data) {
      fetchCartAndUpdate(variantId);
      return data;
    })
    .catch(function (error) {
      console.error('Error:', error);
      window.alert('Sorry, the item could not be added to the cart. Please try again.');
    });
}

function fetchCartAndUpdate(variantId) {
  window.location.href = '/cart';
}

(function () {
  if (window.__fgxCartWired) return;
  window.__fgxCartWired = true;

  document.addEventListener('click', function (event) {

    /* PD-09 plan cards: each button carries its own variant + selling plan */
    var cardBtn = event.target.closest('.pd-sub-card .add-to-cart-btn');
    if (cardBtn) {
      event.preventDefault();
      var cardVariant = parseInt(cardBtn.getAttribute('data-variant-id'), 10);
      var cardPlanAttr = cardBtn.getAttribute('data-selling-plan');
      var cardPlan = cardPlanAttr ? parseInt(cardPlanAttr, 10) : null;
      if (!cardVariant) return;
      cardBtn.disabled = true;
      cardBtn.dataset.originalLabel = cardBtn.textContent;
      cardBtn.textContent = 'Adding to cart…';
      addSubscriptionToCart(cardVariant, 1, cardPlan);
      return;
    }

    /* PD-01 hero: read the active tab panel and selected breed radio */
    var heroBtn = event.target.closest('.pd-hero-add-to-cart');
    if (heroBtn) {
      event.preventDefault();
      var section = heroBtn.closest('.section-pd-hero');
      if (!section) return;
      var subscribePanel = section.querySelector('.pd-purchase-panel[data-panel="subscribe"]');
      var subscribing = subscribePanel && !subscribePanel.hasAttribute('hidden');
      var variantId = null;
      var sellingPlan = null;

      if (subscribing) {
        var radio = subscribePanel.querySelector('input[name="subscription"]:checked');
        if (!radio) return;
        sellingPlan = parseInt(radio.getAttribute('data-selling-plan'), 10);
        variantId = parseInt(radio.closest('.pd-sub-option').getAttribute('data-variant-id'), 10);
      } else {
        var onetimePanel = section.querySelector('.pd-purchase-panel[data-panel="onetime"]');
        variantId = parseInt(onetimePanel.getAttribute('data-variant-id') || '53476666704163', 10);
      }

      if (!variantId) return;
      heroBtn.disabled = true;
      heroBtn.textContent = 'Adding to cart…';
      addSubscriptionToCart(variantId, 1, sellingPlan);
    }
  });
}());
